// TODO:
export enum ShopRenterPageType {
  INFORMATION = "information",
  PRODUCT = "product",
  CATEGORY = "category",
  HOME = "home",
  CART = "cart",
  LOGIN = "login",
  ACCOUNT = "account",
  CHECKOUT_CUSTOMERDATA = 'checkout_customerdata',
  CHECKOUT_SHIPPINGMETHOD = 'checkout_shippingmethod',
  CHECKOUT_PAYMENTMETHOD = 'checkout_paymentmethod',
  CHECKOUT_CONFIRMATION = 'checkout_confirmation',
  POSTPURCHASE = 'postpurchase'
}

interface ShopInfo {
  locale?: string,
  currency?: string,
  shopId?: string
}

export interface ShopRenterCommonInfo extends ShopInfo {
  pageType: ShopRenterPageType
};

export interface IShopRenterProduct {
  id: number,
  sku: string,
  parent: IShopRenterProduct
}

export interface ShopRenterProductInfo extends ShopRenterCommonInfo {
  pageType: ShopRenterPageType.PRODUCT
  product: Partial<IShopRenterProduct>
};

export interface ShopRenterCategoryInfo extends ShopRenterCommonInfo {
  pageType: ShopRenterPageType.CATEGORY
  category: Partial<{
    categoryHandle: string
  }>
};

export type ShopRenterInfo = ShopRenterProductInfo | ShopRenterCategoryInfo | ShopRenterCommonInfo;